import React, {
  forwardRef,
  useRef,
  useContext,
  useEffect,
  // useState,
  useImperativeHandle,
  // useMemo,
} from 'react';
import BasicSettingsStyled from './BasicSettingsStyled';
import {
  TextField,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Select,
  MenuItem,
  FormHelperText,
  useTheme,
  InputAdornment,
  Button,
  // Autocomplete,
} from '@material-ui/core';
import { useForm, Controller } from 'react-hook-form';
import { Context } from '../../AddMarketing';
import IconButton from '@material-ui/core/IconButton';
import ClearIcon from '@material-ui/icons/Clear';
import ClearIconML from '@/components/ClearIconML/index';
import { useIntl } from 'umi';

// eslint-disable-next-line no-unused-vars
export default forwardRef((props, fref) => {
  const {
    marketingId,
    setTitle,
    title,
    type,
    id,
    dateType,
    dateBeginTimestamp,
    dateEndTimestamp,
    dateCycleBeginDay,
    dateCycleEndDay,
    dateFixDay,
    dateFixMonth,
    setDateType,
    setDateFixDay,
    opt,
    handleSubmitSuccess,
    // control,
  } = props || {};
  const intl = useIntl();
  const { formatMessage } = intl;

  const theme = useTheme();
  const { handleSubmit, errors, setValue, control } = useForm();
  // const [fixDay, setFixDay] = useState();

  const day = Array.from(new Array(29).keys()).slice(1);

  useEffect(() => {
    if (id) {
      setValue('title', title);
      setValue('dateFixDay', dateFixDay);
      setValue('dateCycleBeginDay', dateCycleBeginDay);
      setValue('dateCycleEndDay', dateCycleEndDay);
      setValue('dateFixMonth', dateFixMonth);
      // setFixDay(dateFixDay);
      setValue('dateBeginTimestamp', dateBeginTimestamp);
      setValue('dateEndTimestamp', dateEndTimestamp);
      setValue('date', {
        startDate: dateBeginTimestamp,
        endDate: dateEndTimestamp,
      });
    }
  }, [
    dateBeginTimestamp,
    dateEndTimestamp,
    dateFixDay,
    id,
    setValue,
    title,
    dateCycleBeginDay,
    dateCycleEndDay,
    dateFixMonth,
  ]);

  const { ref } = useContext(Context);
  const submitRef = useRef();

  const clickInput = () => {
    submitRef.current.click();
  };

  useImperativeHandle(ref, () => ({
    // handleSubmit 就是暴露给父组件的方法
    clickInput: clickInput,
  }));

  // 清除日期
  const handleClearDay = () => {
    setDateFixDay();
  };

  // 生日营销
  const actionCycle = () => {
    return (
      <div className="birth-wrap">
        <FormControl disabled={opt === 'detail'}>
          <FormLabel component="legend" className="basic-cycle">
            <span className="label-require">*</span>
            {/* 活动周期 */}
            {formatMessage({ id: 'marketing.scene.birth.n01.lbl03' })}
          </FormLabel>
          <Controller
            render={(pr) => (
              <RadioGroup
                aria-label="date"
                name="customized-radios"
                className="cycle-select-wrap checkbox-radio-disabled-color"
                onChange={(e) => {
                  setDateType(e.target.value);
                  // setDateFixDay(e.target.value);
                  return pr.onChange(e.target.value);
                }}
                value={dateType}
              >
                <FormControlLabel
                  value="BIRTHDAY_DAY"
                  control={
                    <Radio color="primary" disabled={opt === 'detail'} />
                  }
                  color="primary"
                  // label="生日当天发放"
                  label={formatMessage({
                    id: 'marketing.scene.birth.n01.rdo04',
                  })}
                />
                <div style={{ color: opt === 'detail' ? 'darkgray' : '' }}>
                  {/* 只有选择了生日当月的才进行校验 */}
                  <FormControlLabel
                    value="BIRTHDAY_MONTH"
                    control={
                      <Radio color="primary" disabled={opt === 'detail'} />
                    }
                    // label="生日当月"
                    label={formatMessage({
                      id: 'marketing.scene.birth.n01.rdo05',
                    })}
                  />
                  <FormControl
                    variant="standard"
                    className="date single-select date-month"
                    disabled={opt === 'detail'}
                  >
                    <Controller
                      render={(rpr) => (
                        <Select
                          disabled={
                            opt === 'detail' || dateType === 'BIRTHDAY_DAY'
                          }
                          onChange={(e) => {
                            setDateFixDay(e.target.value);
                            return rpr.onChange(e.target.value);
                          }}
                          value={
                            dateType === 'BIRTHDAY_MONTH'
                              ? dateFixDay
                              : rpr.value
                          }
                        >
                          {day &&
                            day.map((item) => (
                              <MenuItem key={item.id} value={item} name={item}>
                                {/*  日 */}
                                {item + '日'}
                                {/* {item + formatMessage({ id: 'comm.date.lbl.03' })} */}
                              </MenuItem>
                            ))}
                        </Select>
                      )}
                      label=""
                      name="dateFixDay"
                      defaultValue=""
                      control={control}
                      rules={{
                        required: dateType === 'BIRTHDAY_MONTH',
                      }}
                      disabled={opt === 'detail'}
                      // {...register('dateFixDay', { required: true })}
                    />
                    {opt !== 'detail' && (
                      <ClearIconML
                        disabled={opt === 'detail'}
                        bottom={'10'}
                        right={'8'}
                        handleClick={handleClearDay}
                        clearValue={dateType === 'BIRTHDAY_MONTH' && dateFixDay}
                      ></ClearIconML>
                    )}
                  </FormControl>
                  {/* 发放 */}
                  {formatMessage({ id: 'marketing.scene.birth.n01.rdo06' })}
                </div>
              </RadioGroup>
            )}
            control={control}
            name="couponUsingThreshold"
          />
          <FormHelperText
            error={Boolean(errors.dateFixDay)}
            className="error-wrap"
            sx={{ fontSize: '12px' }}
          >
            {/* {errors.dateFixDay?.type === 'required' &&
              dateType === 'BIRTHDAY_MONTH' &&
              '请选择日期'} */}
            {Boolean(errors.dateFixDay) &&
              dateType === 'BIRTHDAY_MONTH' &&
              // '请选择时间'
              formatMessage({ id: 'marketing.scene.c01.txt02' })}
          </FormHelperText>
        </FormControl>
      </div>
    );
  };

  const editType = (type1) => {
    const showAction = new Map([['BIRTHDAY_ACTIVITY', actionCycle()]]);
    return showAction.get(type1);
  };

  const showActionList = (eid) => {
    const showList = new Map([['1', actionCycle()]]);
    return showList.get(eid);
  };

  const labelML = (
    <>
      <span className="label-require">*</span>
      <span className="label-name">
        {formatMessage({ id: 'marketing.scene.holiday.n01.lbl02' })}
      </span>
    </>
  );

  return (
    <BasicSettingsStyled theme={theme}>
      <form onSubmit={handleSubmit(handleSubmitSuccess)}>
        <div className="basic-title">
          {formatMessage({ id: 'marketing.scene.holiday.n01.lbl01' })}
        </div>
        <Controller
          render={(pr) => (
            <TextField
              variant="standard"
              id="outlined-multiline-static"
              autoComplete="off"
              label={labelML}
              value={pr.value || title || ''}
              placeholder=""
              className="basic-name"
              onChange={(e) => {
                setTitle(e.target.value);
                return pr.onChange(e.target.value);
              }}
              error={Boolean(errors.title)}
              helperText={
                errors.title ? (
                  <span style={{ fontSize: '12px' }}>
                    {formatMessage({ id: 'marketing.scene.c01.txt01' })}
                  </span>
                ) : (
                  ''
                )
              }
              disabled={opt === 'detail'}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      className="clear-btn"
                      onClick={() => {
                        setTitle('');
                        setValue('title', '');
                      }}
                      edge="end"
                      disabled={opt === 'detail'}
                    >
                      {title && <ClearIcon className="clear-icon" />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          )}
          control={control}
          name="title"
          rules={{
            required: true,
            validate: () => {
              if (
                !title ||
                title.trim() === 'null' ||
                title.trim() === '' ||
                title.trim() === undefined
              ) {
                return false;
              }
            },
          }}
        />
        {marketingId && !type && showActionList(marketingId.toString())}
        {type && editType(type)}
        <Button type="submit" ref={submitRef} style={{ display: 'none' }} />
      </form>
    </BasicSettingsStyled>
  );
});
